module.exports = __webpack_public_path__ + "static/0062-febc9e2420e088627f809f7ec5ea1dff.png";